import React from 'react'

function Span() {
  return (
      <div>
          <hr />
          <h2 className='Span'>SALE UP TO 70% OFF FOR ALL CLOTHES & FASHION ITEMS, ON ALL BRANDS.</h2>
        <hr />
      </div>
  )
}

export default Span